export const mockData = {
  business: {
    name: "MSK and Sports Physio",
    email: "mskandsportsphysio@gmail.com",
    phone: "07747075809",
    address: "HarroWall Climbing Centre, Neptune Trading Estate, Neptune Rd, Harrow HA1 4HX",
    hours: "By Appointment - Contact us to schedule"
  },
  
  hero: {
    title: "Regain Strength, Restore Movement",
    subtitle: "Tailored injury rehab & pain management—from sports injuries to post-op recovery",
    cta: "Schedule an Appointment"
  },

  services: [
    {
      id: 1,
      slug: "sports-injury-rehabilitation",
      name: "Sports Injury Rehabilitation",
      description: "Expert treatment for runners, football players, tennis players, and athletes of all sports. Specialized assessment and rehab programs to get you back to peak performance safely.",
      features: ["Running Injury Assessment", "ACL Rehab", "Tennis & Golfers Elbow", "Return to Sport Programs"],
      icon: "activity"
    },
    {
      id: 2,
      slug: "msk-physiotherapy",
      name: "MSK Physiotherapy",
      description: "Evidence-based treatment for muscle, bone, and joint conditions. From back pain and shoulder problems to knee injuries and arthritis management.",
      features: ["Back & Neck Pain", "Shoulder & Knee Problems", "Joint Mobility", "Chronic Pain Management"],
      icon: "stethoscope"
    },
    {
      id: 3,
      slug: "post-operative-rehabilitation",
      name: "Post-Operative Rehabilitation",
      description: "Comprehensive post-surgery rehabilitation programs. We work closely with your surgeon to optimize recovery after ACL reconstruction, joint replacements, and other procedures.",
      features: ["ACL Reconstruction Rehab", "Joint Replacement Recovery", "Post-Surgery Mobilization", "Scar Tissue Management"],
      icon: "hand"
    },
    {
      id: 4,
      slug: "paediatric-sports-physio",
      name: "Paediatric Sports Physio",
      description: "Specialist physiotherapy for young athletes. Expert assessment and treatment of growing pains and sports injuries in children and adolescents.",
      features: ["Growth-Related Pain", "Youth Sports Injuries", "Developmental Assessment", "Activity Modification"],
      icon: "dumbbell"
    },
    {
      id: 5,
      slug: "sports-massage-therapy",
      name: "Sports Massage Therapy",
      description: "Therapeutic deep tissue massage for injury recovery, performance enhancement, and maintenance. Ideal for athletes and active individuals.",
      features: ["Deep Tissue Massage", "Trigger Point Release", "Pre/Post Event Massage", "Soft Tissue Mobilization"],
      icon: "hand"
    },
    {
      id: 7,
      slug: "home-visits",
      name: "Home Visit Physiotherapy",
      description: "Expert physiotherapy delivered in the comfort of your own home across Harrow and surrounding areas. Ideal for post-op recovery, elderly patients, or anyone with limited mobility.",
      features: ["Door-to-Door Service", "Post-Op Recovery at Home", "Elderly & Mobility Care", "Family Members Can Join"],
      icon: "home"
    }
  ],

  team: [
    {
      id: 1,
      name: "Param Jumani",
      role: "Lead Physiotherapist",
      specialty: "Sports Medicine & Paediatric Physiotherapy",
      credentials: "BSc Physiotherapy, MSc Sports Medicine - University of Central Lancashire",
      bio: "Param has extensive experience working within both NHS and private healthcare settings, managing conditions from acute injuries and post-operative recovery to rheumatological and complex sports-related issues. Special interest in adult and paediatric sports injuries.",
      image: "/images/param-jumani.jpg"
    }
  ],

  // Real Google Reviews (5-star verified patients)
  testimonials: [
    {
      id: 1,
      name: "Harnish Patel",
      sport: "Frozen Shoulder & Desk Posture",
      content: "I cannot recommend Param highly enough. I first sought his help for a frozen shoulder and a subsequent shoulder issue following a procedure. From day one, it was clear that Param is incredibly knowledgeable. What sets him apart is his holistic approach; he doesn't just treat the isolated injury but looks at your overall physical health and lifestyle. As someone who works from home and spends 90% of the day at a desk, I struggled with constant stiffness. Param took the time to suggest specific, seated exercises I can do throughout the day to keep my neck and back from seizing up. If you're looking for a physiotherapist who genuinely cares about your long-term recovery and well-being, Param is the one to see.",
      rating: 5
    },
    {
      id: 2,
      name: "Asif Baig",
      sport: "Chronic Lower Back Pain",
      content: "I have been suffering with left sided lower back pain for ages. After consulting with spinal surgeon and an MRI and CT scan later, structural issues were ruled out and physiotherapy was suggested. I was very sceptical about this as I have had physiotherapy before without success. I found Param through recommendations. After a few sessions I started getting relief. He combined hands on therapy with stretching and strengthening exercises. Gently increasing them. After 5 sessions I am relatively pain free after a long time and less living in fear of it recurring. I still need a few more sessions and exercises under his expert supervision but I am very optimistic now. Param is also a very gentle and pleasant young man. Thank you, Param. Highly recommend.",
      rating: 5
    },
    {
      id: 3,
      name: "Shaneil Sarkar",
      sport: "Physiotherapy Recovery",
      content: "I've been seeing Param for physiotherapy and I cannot recommend him highly enough. He's incredibly knowledgeable, attentive, and a great listener. Param really takes the time to understand your situation before tailoring a rehab plan that works specifically for you. Since starting my sessions with Param, I've seen fantastic improvements and feel much more confident in my recovery. Param's professionalism and genuine care make a huge difference — an excellent physio all around!",
      rating: 5
    },
    {
      id: 4,
      name: "Noorie N",
      sport: "Running Injuries",
      content: "I had a great experience with Param for runner-related issues. He was very patient and took the time to clearly explain everything throughout the session. While I was doing the exercises, he carefully observed my form and checked for any issues that might not be immediately obvious. He also provided me with a tailored exercise program and practical guidance on how to maintain my progress and prevent future injuries. Overall, very knowledgeable, professional, and thorough.",
      rating: 5
    },
    {
      id: 5,
      name: "Joseph Peeris",
      sport: "Muscle Spasms & Lower Back Pain",
      content: "I have been receiving physiotherapy treatment from Param for muscle spasms and lower back pain. From the outset, Param demonstrated excellent diagnostic skills, quickly identifying the underlying issue and developing an effective treatment plan. His hands-on therapy during sessions has provided significant relief, and the stretching exercises he recommended for daily practice have greatly improved my overall mobility and comfort. Param combines professionalism, expertise, and a caring approach, and I would highly recommend him to anyone seeking high-quality physiotherapy care.",
      rating: 5
    },
    {
      id: 6,
      name: "CL0V3R_L0RD",
      sport: "Shoulder Dislocation & Return to Sport",
      content: "I was suffering from shoulder dislocation and Param is very knowledgeable explaining to me the issues and the necessary steps for the rehab and guided me through the journey to return back to sport. Gave great exercises that progressed after each session. Would highly Recommend.",
      rating: 5
    }
  ],

  // Google Maps Review Link - Actual Business Profile
  googleMapsReviewUrl: "https://share.google/rMiCmNQ2wpRkYgkKl",

  partners: [
    {
      name: "AXA Health",
      logo: "/images/partners/axa.png"
    },
    {
      name: "Bupa",
      logo: "/images/partners/bupa.png"
    },
    {
      name: "Aviva",
      logo: "/images/partners/aviva.png"
    },
    {
      name: "Vitality",
      logo: "/images/partners/vitality.png"
    },
    {
      name: "WPA",
      logo: "/images/partners/wpa.png"
    }
  ],

  faqs: [
    {
      id: 1,
      question: "Do I need a referral from my GP?",
      answer: "No referral is needed. You can book directly with us for an assessment. However, if you're using private health insurance, please check with your provider about their specific requirements."
    },
    {
      id: 2,
      question: "What insurance providers do you work with?",
      answer: "We work with major health insurance providers including AXA Health, Bupa, Aviva, Vitality, and WPA. We can provide detailed receipts for you to claim from your insurance company."
    },
    {
      id: 3,
      question: "What should I bring to my first appointment?",
      answer: "Please bring any relevant medical reports, imaging results (X-rays, MRI scans), and wear comfortable clothing that allows easy access to the affected area. If using insurance, bring your membership details."
    },
    {
      id: 4,
      question: "Do you treat children and young athletes?",
      answer: "Yes! Param has specialist training in paediatric physiotherapy and extensive experience treating sports injuries in children and adolescents."
    },
    {
      id: 5,
      question: "Where are you located?",
      answer: "We are based inside HarroWall climbing centre. Contact us at 07747075809 or mskandsportsphysio@gmail.com to schedule an appointment and get specific location details."
    },
    {
      id: 6,
      question: "How long is a typical session?",
      answer: "Initial assessments take 45 minutes. Follow-up treatments are usually 30 minutes."
    }
  ]
};
